'use strict';

define('off-canvas-menu',['jquery', 'slider', 'opts', 'search'], function ($, Slider, opts, search) {

  var
    IS_OPEN             = 'is-menu-opened',
    NO_SCROLL           = 'no-scroll',
    $searchField        = $('#search-field');

  var
    $body               = $('body'),
    $loginModalPortal   = $('#loginModalPortal'),
    $openButton         = $('#js-menu-open'),
    $closeButton        = $('#js-menu-close'),
    $mask               = $('#mask');

  var
    local_opts = {
      animation_duration: 600,
      autorotate_delay: 650,
      login_modal_close_duration: 50
    };

  var closeLoginModal = function() {
    $loginModalPortal.foundation('reveal','close', {
      animation_speed: local_opts.login_modal_close_duration
    });
  };

  var openMenu = function() {
    $body.addClass(IS_OPEN);
    Slider.stop();
    toggleBodyScroll();
    closeLoginModal();
    return false;
  };

  var toggleBodyScroll = function(make_it_visible) {
    if(opts.browser.mozilla) {
      // fix for the issue in FF when body { overflow: hidden } disables animation
      setTimeout(function(){
        updateCssClass();
      }, local_opts.animation_duration);
    }
    else {
      updateCssClass();
    }

    function updateCssClass() {
      if(make_it_visible) {
        $body.removeClass(NO_SCROLL);
      }
      else {
        $body.addClass(NO_SCROLL);
      }
    }
  };

  var closeMenu = function() {
    $body.removeClass(IS_OPEN);
    Slider.start(opts.autorotate_delay);
    toggleBodyScroll(true);
    // search.clear(); //Can't seem to fnd the search reference here, the below code works
    $searchField.val('');
  };

  var toggleMenu = function() {
    if(isMenuOpen()) {
      closeMenu();
    }
    else {
      openMenu();
    }
    return false;
  };

  var isMenuOpen = function() {
    return $body.hasClass(IS_OPEN);
  };

  var attachEvents = function() {
    $openButton.click(toggleMenu);
    $closeButton.click(closeMenu);
    $mask.click(closeMenu);
  };

  var initialize = function() {
    attachEvents();
  };

  return {
    init: initialize
  };
});
